const REACT_APP_VMS_BASE_URL = "https://api.kjl.co.tz:4000";
const REACT_APP_ARPS_BASE_URL = "https://api.kjl.co.tz:3000";
const REACT_APP_EMAIL_BASE_URL = "https://api.kjl.co.tz:8080";

// const REACT_APP_VMS_BASE_URL = "http://localhost:4000";
// const REACT_APP_ARPS_BASE_URL = "http://localhost:3000";
// const REACT_APP_EMAIL_BASE_URL = "http://localhost:8080";

export {
  REACT_APP_VMS_BASE_URL,
  REACT_APP_ARPS_BASE_URL,
  REACT_APP_EMAIL_BASE_URL,
};
